import React, { createContext, useState, useEffect } from "react"
import en from "../locales/en"
import es from "../locales/es"

const LanguageContext = createContext()

export const LanguageProvider = ({ children }) => {
  // Detectamos el idioma por defecto del navegador (si está en el cliente)
  const defaultLanguage =
    typeof window !== "undefined" &&
    window.navigator.language.toLowerCase().startsWith("es")
      ? "es"
      : "en"

  const [language, setLanguage] = useState(defaultLanguage)

  // Diccionarios disponibles
  const translations = { en, es }

  // Al montar, chequeamos si en localStorage ya había un idioma guardado
  useEffect(() => {
    if (typeof window !== "undefined") {
      const storedLang = localStorage.getItem("gatsbyLang")
      if (storedLang) {
        setLanguage(storedLang)
      }
    }
  }, [])

  // Cada vez que cambie language, lo guardamos en localStorage
  useEffect(() => {
    if (typeof window !== "undefined") {
      localStorage.setItem("gatsbyLang", language)
    }
  }, [language])

  // Función para obtener la traducción de una key
  const t = (key) => {
    // Si no existe la key, devolvemos la propia key como fallback
    return translations[language][key] || key
  }

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  )
}

export default LanguageContext
